var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.75 6.875-3.671 3.671a.722.722 0 0 1-.527.225.762.762 0 0 1-.541-.23.745.745 0 0 1-.22-.53c0-.202.076-.378.226-.528l4.96-4.954a.722.722 0 0 1 .526-.216c.1 0 .194.017.282.052a.69.69 0 0 1 .236.156l4.958 4.958a.72.72 0 0 1 .23.521.733.733 0 0 1-.22.52.766.766 0 0 1-.545.23.71.71 0 0 1-.527-.23L11.25 6.876v8.376c0 .212-.072.39-.214.534a.72.72 0 0 1-.532.215.734.734 0 0 1-.535-.216.72.72 0 0 1-.219-.534V6.876Z",
    fill: "#DE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.39dacb02bf1777666ee7836564b09240.svg";
export { ForwardRef as ReactComponent };